import React from 'react';
import { styled } from 'styled-components';
import dayjs from 'dayjs';

import Column from 'components/common/Column';
import Row from 'components/common/Row';
import Text from 'components/common/Text';
import { InvoiceEdge, InvoiceNode } from '../graphQL/types';
import BasicButton from 'components/Button/BasicButton';
import SettlementBadge from 'containers/SettlementRequest/components/SettlementBadge';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

interface InvoiceListIProps {
  invoiceItem: InvoiceEdge;
  handleOpenDetailModal: (invoice: InvoiceNode) => void;
}

const InvoiceList: React.FC<InvoiceListIProps> = props => {
  const { invoiceItem, handleOpenDetailModal } = props;

  const renderInvoiceItem = (
    title: string,
    value: string | React.ReactElement,
  ): JSX.Element => {
    return (
      <Row justifyContent="space-between" style={{ width: '100%' }}>
        <Text color="#46474C">{title}</Text>
        {value}
      </Row>
    );
  };

  return (
    <Container>
      <Column gap="12px">
        {renderInvoiceItem(
          '상태',
          <SettlementBadge status={invoiceItem.node.status} />,
        )}
        {renderInvoiceItem(
          '요청일',
          <Text color="#70737C" weight={400}>
            {dayjs(invoiceItem.node.createdAt).format('YYYY년 MM월 DD일')}
          </Text>,
        )}
        {renderInvoiceItem(
          '진행 시작일',
          <Text color="#70737C" weight={400}>
            {invoiceItem.node.startedAt !== null
              ? dayjs(invoiceItem.node.startedAt).format('YYYY년 MM월 DD일')
              : '-'}
          </Text>,
        )}
        {renderInvoiceItem(
          '완료일',
          <Text color="#70737C" weight={400}>
            {invoiceItem.node.completedAt !== null
              ? dayjs(invoiceItem.node.completedAt).format('YYYY년 MM월 DD일')
              : '-'}
          </Text>,
        )}
        {renderInvoiceItem(
          '총 지급액',
          <Text color="#70737C" weight={400}>
            {Number(invoiceItem.node.totalPayment.value).toLocaleString()}원
          </Text>,
        )}
        {renderInvoiceItem(
          '계좌 정보',
          <Text color="#70737C" weight={400}>
            {`${invoiceItem.node.bankAccount.bank.name} ${invoiceItem.node.bankAccount.accountNo} ${invoiceItem.node.bankAccount.holder}`}
          </Text>,
        )}
      </Column>
      <BasicButton
        content={
          <Text color="#46474C" size="14px" weight={400}>
            자세히 보기
          </Text>
        }
        style={{ padding: '12px 0', borderRadius: '8px' }}
        onClick={() => handleOpenDetailModal(invoiceItem.node)}
      />
    </Container>
  );
};

export default InvoiceList;
